import * as React from 'react';
import {Box, Typography} from '@mui/material';
import {dayLabel, formatNumber} from '../../utilities/dashboard';

// What the pointer is over: the day, then each series with its colour as a short line, the value first and strongest and the name
// beside it. Text only: every name and number is rendered as text, never as markup.
export function ChartTooltip({active, payload, label}: { active?: boolean, payload?: readonly { name?: unknown, value?: unknown, color?: string }[], label?: unknown }) {
    if (!active || !payload?.length) return null;

    return (
        <Box sx={{bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 1, boxShadow: 2, px: 1.5, py: 1}}>
            <Typography variant="caption" color="text.secondary">{typeof label === 'string' ? dayLabel(label) : String(label ?? '')}</Typography>
            {payload.map((item) => (
                <Box key={String(item.name)} sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                    <Box component="span" aria-hidden sx={{width: 12, height: 0, borderTop: '3px solid', borderColor: item.color, flexShrink: 0}}/>
                    <Typography variant="body2" component="span" fontWeight={600} sx={{fontVariantNumeric: 'tabular-nums'}}>{formatNumber(Number(item.value))}</Typography>
                    <Typography variant="body2" component="span" color="text.secondary">{String(item.name)}</Typography>
                </Box>
            ))}
        </Box>
    );
}
